import { styled } from "@mui/material/styles"
import Typography from "@mui/material/Typography"

export const Subtitle = styled(Typography)(({ theme }) => ({
  fontSize: "1.1rem",
  fontWeight: 700,
  color: theme.palette.gray["15"],
  marginBottom: "4px"
}))
